var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpiThresholdUpV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_113119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.8511H32C32 24.6876 24.8366 31.8511 16 31.8511C7.16344 31.8511 0 24.6876 0 15.8511Z",
    fill: "#CBEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8512H28.448V17.4512H32V15.8512ZM24.896 15.8512H21.344V17.4512H24.896V15.8512ZM17.792 15.8512H14.24V17.4512H17.792V15.8512ZM10.688 15.8512H7.136V17.4512H10.688V15.8512ZM3.584 15.8512H0V17.4512H3.552V15.8512H3.584Z",
    fill: "#A0D9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52 4.90686L30.624 12.3789C30.592 12.6189 30.288 12.7309 30.112 12.5549L27.888 10.3309L17.712 20.5069C17.472 20.7469 17.104 20.7469 16.864 20.5069L13.04 16.6989L2.67198 27.0509C2.67198 27.0509 2.54398 27.1309 2.46398 27.1309C2.38398 27.1309 2.30398 27.0989 2.25598 27.0509L0.55998 25.3549C0.55998 25.3549 0.47998 25.2269 0.47998 25.1469C0.47998 25.0669 0.51198 24.9869 0.55998 24.9389L12.624 12.8749C12.864 12.6349 13.232 12.6349 13.472 12.8749L17.296 16.6829L25.776 8.20286L23.552 5.97886C23.552 5.97886 23.488 5.88286 23.472 5.83486C23.472 5.78686 23.472 5.72286 23.472 5.67486C23.488 5.62686 23.52 5.57886 23.568 5.54686C23.616 5.51486 23.664 5.48286 23.728 5.48286L31.2 4.58686C31.392 4.55486 31.552 4.73086 31.536 4.92286L31.52 4.90686Z",
    fill: "#62BFC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_113119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27.28,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 31.8511)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiThresholdUpV2);
export default __webpack_public_path__ + "static/media/kpi-threshold-up-v2.fcb83c3d.svg";
export { ForwardRef as ReactComponent };